import { FAQPageJsonLd, NextSeo } from 'next-seo';
import React, { useEffect, useState } from 'react';
import { OvulutionCalculatorFooterData } from '../../../src/Constants/SEOStaticData';
import { iosHideTopBar } from '../../../src/Utils/IosUtils';
import { isDesktopUser } from '../../../src/Utils/ProductUtils';
import {
  androidDisablePullRefresh,
  enableAndroidBack,
  hideAndroidBottomBar,
  hideAndroidTopBar,
} from '../../../src/Utils/androidUtils';
import {
  getFilteredCategoryContent,
  isAndroidAppUser,
  isIOSAppUser,
} from '../../../src/Utils/helper';
import { getSeoVisibility } from '../../../src/appconfig';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import Tools from '../../../src/components/HomePage/Tools';
import OvulationCalculator from '../../../src/components/OvulationTool';
import OvulationArticles from '../../../src/components/OvulationTool/OvulationArticles';
import { ovulationBreadcrumbs } from '../../../src/components/OvulationTool/staticData';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import { utilitesFetcher } from '../../../src/datafetchers/HomePage';
import { storeDataFetcher } from '../../../src/datafetchers/Store';
import GlobalStyle from '../../../src/styles/globalStylesV2';

export async function getStaticProps() {
  const toolsData = await utilitesFetcher();
  let data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      tools: toolsData,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
    },
    revalidate: 300,
  };
}

export default function OvulationTool(props) {
  const { tools, categoryData } = props;
  const [hideHamIcon, setShowHamIcon] = useState(false);
  const [showIconForIos, setShowIconForIos] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [desktop, setDesktop] = useState(false);
  const [hidePaddingForAndroid, setHidePaddingForAndroid] = useState(false);

  const metaTitle =
    'Ovulation Calculator and Calendar - Track Your Most Fertile Days';
  const metaDescription =
    "Mylo's ovulation calculator gives you the tentative dates of your fertility window when you give last menstrual period and average cycle length we determine your ovulation day";
  const heading = OvulutionCalculatorFooterData.heading;
  const htmlText = OvulutionCalculatorFooterData.htmlText;
  const FAQPage = OvulutionCalculatorFooterData.faqs;
  const canonicalUrl =
    'https://mylofamily.com/tools/ovulation-calculator-fertility-calendar';
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    locale: 'en',
    url: canonicalUrl,
    images: [
      {
        url: 'https://images.myloapp.in/mydo_upload/mydo_upload_1594374410_935842044.png',
        width: 800,
        height: 800,
      },
    ],
  };

  useEffect(() => {
    if (isAndroidAppUser()) {
      hideAndroidTopBar();
      enableAndroidBack(true);
      hideAndroidBottomBar();
      androidDisablePullRefresh();
      setShowHamIcon(true);
      setShowHeader('-56px');
      setHidePaddingForAndroid(true);
    }
    if (isIOSAppUser()) {
      iosHideTopBar();
      setShowHamIcon(true);
      setHidePaddingForAndroid(true);
      setShowIconForIos(true);
    }
    setDesktop(isDesktopUser());
  }, []);
  const requiredTools = [3, 0, 0];
  const productData = {
    id: '-1',
    name: 'Ovulation Calculator Page',
  };

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
            canonical={canonicalUrl}
          />
          <FAQPageJsonLd mainEntity={FAQPage} />
        </>
      ) : null}
      <GlobalStyle />
      {!hideHamIcon && (
        <NewHeader
          hideMobileSearch={true}
          hideLogin={true}
          showHeader={showHeader}
          hideHamIcon={showIconForIos}
          categoryData={categoryData}
          nostrip={true}
        />
      )}

      <HomeWrapper hidePaddingForAndroid={hidePaddingForAndroid}>
        {!hideHamIcon && (
          <>
            <Breadcrumbs breadCrumbs={ovulationBreadcrumbs} addClass={true} />
          </>
        )}

        <OvulationCalculator productData={productData} />
        {!hideHamIcon && (
          <Tools
            heading={'EXPLORE MORE HELPFUL TOOLS'}
            data={tools?.data}
            gridCount={'5'}
            requiredTools={requiredTools}
            ovulation={true}
          />
        )}
        {!hideHamIcon && <OvulationArticles heading="Read More On Mylo" />}
      </HomeWrapper>
      {!hideHamIcon && <NewFooter heading={heading} content={htmlText} />}
    </>
  );
}
